import { render, staticRenderFns } from "./AscAlertDescriptionsItem.vue?vue&type=template&id=6c906f25&scoped=true&"
import script from "./AscAlertDescriptionsItem.vue?vue&type=script&lang=js&"
export * from "./AscAlertDescriptionsItem.vue?vue&type=script&lang=js&"
import style0 from "./AscAlertDescriptionsItem.vue?vue&type=style&index=0&id=6c906f25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c906f25",
  null
  
)

export default component.exports